import styles from './widget_temperature.module.scss';

interface OwnProps {
    value: number;
}

export function WidgetTemperature({value}: OwnProps) {
    return (
        <div className={styles.widget_temperature}>
            <span>{value}</span>
        </div>
    );
}
